define.alias("ember-truth-helpers/helpers/and", "media/helpers/and");